'use strict';

var $ = require('jquery');
var toggle = require('../toggle');
var ajax = require('../../utils/ajax');
var util = require('../../utils/util');
var offcanvasdialog = require('../offcanvasdialog');
const minicart = require('../header/minicart');
const cartoverlay = require('../checkout/cartoverlay');
var membersOnlyFlyin = require('../../flyins/membersonlyflyin');
var progress = require('../../utils/progress');
var uniform = require('../uniform');
var pdpsize = require('./pdpsize');
var addToCart = require('../../pages/product/addToCart');
var variationValidation = require('../../pages/product/validVariation.js');
var wishlist = require('../../pages/wishlist');
var hotspots = require('../hotspots');
var util = require('../../utils/util');
var productTabs = require('./product-tabs');
const gtmTracking = require('../tracking/tracking');
const Dialog = require('../../lib/dialog').default;
const variationCarousel = require('../../productdetail/variation-carousel');
const fitguide = require('./fitguide');
const optiTracking = require('../tracking/optimizely');
const optiExperiment = require('../optimizelyExperimentation');

import loadVideo from '../../pages/product/video/youtube';

let modalDialog;

/**
 * @description update "add product set to cart" button based on the validity of individual product set items
 */
var updateAddAllToCartButton = function ($content) {
    if ($content.find('.product-set-item .add-to-cart-disabled').length) {
        $content.find('#add-all-to-cart').addClass('add-to-cart-disabled');
    } else {
        $content.find('#add-all-to-cart').removeClass('add-to-cart-disabled');
    }
};

/**
 * @description update product content with new variant from href, load new content to #product-content panel
 * @param {String} href - url of the new product variant
 */
function updateContent(href, $content) {
    var params = {
        format: 'ajax'
    };

    var $close = $content.find('.ocd-close').detach();

    progress.show($content);

    if (href.indexOf('groupSize') < 0) {
        href += '&groupSize=' + $('#groupSize').val(); // eslint-disable-line no-param-reassign
    }

    ajax.load({
        url: util.appendParamsToUrl(href, params),
        target: $('.ocd-flyin.quick-shop .ocd-content'),
        callback: function () {
            var $quickShopFlyInContainer = $('.ocd-flyin.quick-shop .ocd-content');
            $content.append($close);
            initFlyIn($quickShopFlyInContainer);
            $('#groupSize').attr('value', util.getParameterByName('groupSize', href));
        }
    });
}

/**
 * @description update product dialog content with new variant from href
 * @param {String} href - url of the new product variant
 */
function updateDialogContent(href, $content, isColorChange) {
    var params = {
        format: 'ajax',
        isColorChange
    };

    progress.show($content);

    if (href.indexOf('groupSize') < 0) {
        params.groupSize = $('#groupSize').val();
    }

    ajax.load({
        url: util.appendParamsToUrl(href, params),
        target: $content,
        callback: function () {
            var $dialogContainer = $('.quickshop-dialog .dialog-content');
            initDialogContent($dialogContainer);
            $('#groupSize').attr('value', util.getParameterByName('groupSize', href));
        }
    });
}

/**
 * @description update product set item dialog content with new variant from href
 * @param {String} href - url of the new product variant
 */
function updateDialogSetItemContent(href, $content, isColorChange) {
    var params = {
        format: 'ajax',
        issetitem: true,
        isColorChange
    };

    progress.show($content);

    if (href.indexOf('groupSize') < 0) {
        params.groupSize = $('#groupSize').val();
    }

    ajax.load({
        url: util.appendParamsToUrl(href, params),
        target: $content,
        callback: function () {
            var $dialogContainer = $('.quickshop-dialog .dialog-content');
            initDialogContent($dialogContainer);
            $('#groupSize').attr('value', util.getParameterByName('groupSize', href));
        }
    });
}

/**
 * @description update product in-grid content with new variant from href
 * @param {String} href - url of the new product variant
 * @param {Object} $content - content container
 */
function updateInGridContent(href, $content) {
    var params = {
        format: 'ajax',
        ingrid: true
    };

    progress.show($content);

    if (href.indexOf('groupSize') < 0) {
        params.groupSize = $('#groupSize').val();
    }

    ajax.load({
        url: util.appendParamsToUrl(href, params),
        target: $content,
        callback: function () {
            $('#groupSize').attr('value', util.getParameterByName('groupSize', href));
            initVariantSelection($content);
        }
    });
}

var quickshopImageArrows = function ($container) {
    var $bubbles = $container.find('.bubble');
    var $arrows = $container.find('.nav-direct');

    $arrows.off('click').on('click', function (event) {
        var direction = $(this).hasClass('nav-prev') ? 'prev' : 'next';
        var $bubble = $bubbles.filter('.active')[direction]();

        event.preventDefault();

        if ($bubble.length) {
            $bubble.trigger('click');
        }
    });
};

var changeRegion = function ($container) {
    $container.on('click keypress', '.size-region a, .attribute.size .form-row-radio.region-select', function (event) {
        // pdp size
        if (util.isClickOrSpaceOrEnter(event)) {
            var $containers = $('.attribute.size'); // change all instances for Product Sets
            var $regionGroups = $containers.find('.sizes .RegionGroup');
            var selectedRegion = '';
            if ($(this).hasClass('form-row-radio')) {
                selectedRegion = $(this).find('input').val();
                var $selectedRadios = $containers.find('input[value="' + selectedRegion + '"]');

                activateRegionGroup($regionGroups, selectedRegion);

                if ($selectedRadios && $selectedRadios.length > 1) {
                    $selectedRadios.parent('span').addClass('checked');
                }
            } else {
                var firstRegion = $(this).first();
                if (firstRegion.length > 0) {
                    selectedRegion = firstRegion.text();
                }

                var $tabLinks = $containers.find('.size-region a');

                $tabLinks.each(function () {
                    $(this).removeClass('tab-selected');
                    $(this).attr('aria-checked', false);
                });
                $(this).addClass('tab-selected');
                $(this).attr('aria-checked', true);
                activateRegionGroup($regionGroups, selectedRegion);
            }
        }
    });
};

var activateRegionGroup = function activateRegionGroup(regionGroups, selectedRegion) {
    $(regionGroups).removeClass('active activeSize');
    $(regionGroups)
        .filter(function () {
            return $(this).attr('id') === selectedRegion;
        })
        .addClass('active activeSize');
};

/**
 * @description Request all product images asynchronously and init slider on them
 */
var initImageslider = function ($qsFlyInContent) {
    var currentPid = $qsFlyInContent.find('.product-primary-image').data('pid');
    var url = util.appendParamsToUrl(util.ajaxUrl(Urls.getSliderImages), {
        pid: currentPid,
        source: 'quickshop'
    });
    var $sliderContainer = $qsFlyInContent.find('.product-images-top').find('.main-image-slider .slider-images');
    var $defImageContainer = $qsFlyInContent.find('.product-images-top').find('.main-image-slider .default-image');

    ajax.load({
        url: url,
        target: $sliderContainer,
        callback: function () {
            $('.slider-tiles')
                .not('.slick-initialized')
                .slick({
                    autoplay: false,
                    lazyLoad: 'ondemand',
                    dots: true,
                    dotsClass: 'slick-dots-custom',
                    rtl: document.documentElement.lang === 'ar' ? true : false,
                    slidesToShow: 1,
                    slideToScroll: 1,
                    draggable: false,
                    prevArrow: $('.main-image-arrows-left'),
                    nextArrow: $('.main-image-arrows-right')
                });
            quickshopImageArrows($qsFlyInContent);
            $sliderContainer.show();
            $defImageContainer.hide();
        }
    });
};

/**
 * @description Request all product images for quick-shop dialog asynchronously and init them
 */
var initImages = function ($qsFlyInContent) {
    const $productSlick = $('.quickshop-dialog .quickshop-product-image-slick');
    const $slidesCount = $productSlick.find('.grid-tile');

    $productSlick.not('.slick-initialized').slick({
        autoplay: false,
        infinite: false,
        arrows: false,
        rtl: document.documentElement.lang === 'ar' ? true : false,
        dots: false,
        slidesToShow: $slidesCount.length,
        slideToScroll: 1,
        draggable: false,
        vertical: true,
        verticalScrolling: true,
        adaptiveHeight: false
    });

    $productSlick.slick('setPosition');
    $productSlick.slick('resize');
};

function updateMiniCart(response, showOverlay) {
    var splitted = response.split(util.contentSplitter);
    var options = {};
    if ($(response).filter('.sign-in-to-buy-error-message').length > 0) {
        membersOnlyFlyin.init(e.target);
        return;
    }
    if (splitted && splitted.length) {
        try {
            options = JSON.parse(splitted[1]);
        } catch (err) {
            // nothing to do, default value is {}
        }

        if (showOverlay && splitted[2]) {
            cartoverlay.show(splitted[2]);
        }

        if (splitted[0]) {
            minicart.update(splitted[0], options);
        }
    }
}
/**
 * @description Initialize the quick shop add to cart
 */
function initAddToCart($content) {
    $content.find('.add-to-cart').on('click', function (e) {
        e.preventDefault();
        const $this = $(this);
        const $form = $this.closest('form');

        // Check if adding to the cart is not available
        if (
            $this.hasClass('member-shop') ||
            $this.hasClass('pre-order-button') ||
            $this.hasClass('member-exclusives') ||
            $this.hasClass('sign-in-to-buy')
        ) {
            offcanvasdialog.closeAll();
            if (modalDialog || $content.hasClass('product-tile-quickshop-view')) {
                // Modal dialog and in-grid case
                if (modalDialog) {
                    modalDialog.close();
                } else {
                    $('.product-tile-quickshop-view').fadeOut();
                }
                membersOnlyFlyin.init($content);
            } else {
                // Fly-in case
                // Wait for the quickshop fly-in to fully close before opening the Registering fly-in.
                $('.ocd-flyin').on('hidden', function () {
                    $(this).off('hidden');
                    membersOnlyFlyin.init(e.target);
                });
            }
        } else {
            addToCart.addItemToCart($form).then(function (response) {
                offcanvasdialog.closeAll();
                if (modalDialog || $content.hasClass('product-tile-quickshop-view')) {
                    // Modal dialog and in-grid case
                    const price = $('#pdpMain').find('.component.price').data('price');
                    optiTracking.pushEventToOptimizely('ADD_TO_CART', price);
                    optiExperiment.trackEvent('addToCart');
                    if (modalDialog) {
                        modalDialog.close();
                    } else {
                        $('.product-tile-quickshop-view').fadeOut();
                    }
                    updateMiniCart(response, true);
                } else {
                    // Fly-in case
                    // Wait for quickshop fly-in to fully close before opening the Shopping Cart fly-in.
                    $('.ocd-flyin').on('hidden', function () {
                        $(this).off('hidden');
                        updateMiniCart(response, true);
                    });
                }
                const evt = new Event('quick-shop-done');
                evt.pid = $form.find('input[name=pid]').val();
                $content[0].dispatchEvent(evt);

                if (window.pageContext.ns !== 'wishlist') {
                    gtmTracking.trackQuickShopAddToCart();
                }
            });
        }
    });

    $content.find('#add-all-to-cart:not(.add-to-cart-disabled)').on('click', function (e) {
        e.preventDefault();

        let productForms = $('.product-set-item form.quickShopForm').toArray();
        let lastForm = productForms[productForms.length - 1];
        let setId = $('#pdpMain').data('id');
        productForms.pop();

        Promise.all(productForms.map(addToCart.addItemToCart)).then(function () {
            addToCart.addItemToCart(lastForm, setId).then(function (response) {
                const price = $('#pdpMain').find('.component.price').data('price');
                optiTracking.pushEventToOptimizely('ADD_TO_CART', price);
                optiExperiment.trackEvent('addToCart');

                modalDialog.close();
                updateMiniCart(response, true);
            });
        });
    });
}

/**
 * @description Initialize the quick shop variant selection
 */
function initVariantSelection($content) {
    // click on swatch - should replace content with new variant
    $content.find('.swatchanchor').on('click', function (e) {
        var href;
        e.preventDefault();

        if ($(this).parents('li').hasClass('unselectable') || $(this).parents('li').hasClass('selected')) {
            return;
        }

        href = this.href || this.getAttribute('data-href');

        if ($content.hasClass('product-tile-quickshop-view')) {
            updateInGridContent(href, $content);
        } else if ($content.hasClass('dialog-content')) {
            const $swatch = $(this);
            const isColorChange = $swatch.hasClass('color');
            if ($swatch.is('.product-set-item .swatchanchor')) {
                updateDialogSetItemContent(href, $swatch.closest('.product-set-item'), isColorChange);
            } else {
                updateDialogContent(href, $content, isColorChange);
            }
        } else {
            updateContent(href, $content);
        }
    });

    if ($content.find('.product-set-item').length) {
        variationValidation.initQuickShopSetValidation();
    } else {
        variationValidation.initQuickShopValidation();
    }

    updateAddAllToCartButton($content);
    initAddToCart($content);
}

/**
 * @description Initialization AvailabilityReminder close quickshop to open AvailabilityReminder
 */
function initAvailabilityReminder($qsFlyInContent) {
    $qsFlyInContent.find('.unselectable').on('click', function (e) {
        e.preventDefault();
        $qsFlyInContent.find('.ocd-close').click();
    });
}

/**
 * @description Initialization on the quick shop flyIn content
 */
function initFlyIn($qsFlyInContent, isSet) {
    uniform();
    pdpsize.init('.ocd-flyin.quick-shop .ocd-content');
    initImageslider($qsFlyInContent);
    toggle.init();
    productTabs.init();
    initAvailabilityReminder($qsFlyInContent);

    if (!isSet) {
        variationValidation.initQuickShopValidation();
        initVariantSelection($qsFlyInContent);
        wishlist.initWishlistQuickShop();
        changeRegion($qsFlyInContent);
    }

    if (window.pageContext.ns !== 'wishlist') {
        gtmTracking.trackQuickShopMoreDetails();
    }
}

function PopupTip() {
    const {createPopper} = require('@popperjs/core');

    $('.marks-items').each(function () {
        var $thisElement = $(this);
        var thisID = $(this).attr('id');
        let containerId = 'container-' + thisID;

        $thisElement.attr('title', thisID);
        $thisElement.attr('isTipOpen', false);

        var href = Urls.quickShopTip;
        var params = $thisElement.find('a').attr('href').split('?')[1];
        var quickShopURL = href + '?' + params;

        if (quickShopURL.indexOf('&color=') > -1) {
            var urlSplit = quickShopURL.split('&color=');
            quickShopURL = urlSplit[0] + '_' + urlSplit[1];
        }

        ajax.load({
            url: quickShopURL,
            data: {
                containerId: containerId
            },
            callback: function (data) {
                $thisElement.after(data);

                let button = $thisElement[0];
                let tooltip = document.querySelector('#' + containerId);

                if (tooltip) {
                    let popperInstance = createPopper(button, tooltip, {
                        placement: 'top-end'
                    });

                    button.addEventListener('click', e => {
                        e.preventDefault();

                        let visible = tooltip.hasAttribute('data-show');

                        if (visible) {
                            tooltip.removeAttribute('data-show');
                        } else {
                            tooltip.setAttribute('data-show', '');
                        }

                        // Update its position
                        popperInstance.update();
                    });
                }
            }
        });
    });

    $('.marks-items').each(function (i, element) {
        var link = $(this).find('a').attr('href');
        if (link.indexOf('&color=') > -1) {
            var linkSplit = link.split('&color=');
            link = linkSplit[0] + '_' + linkSplit[1];
        }

        var dialog = offcanvasdialog.init(
            `quickshop-${util.getParameterByName('pid', link)}`,
            {
                overlay: true,
                preventScroll: true,
                contentStyle: 'overlaid',
                closeOnX: true,
                reloadContentAlways: true,
                additionalClass: 'quick-shop'
            },
            function ($triggerButton, $flyinContainer) {
                var $qsFlyInContent = $flyinContainer.find('.ocd-content');
                initFlyIn($qsFlyInContent);
            }
        );

        $(element).on('click', function (event) {
            event.preventDefault();

            if ($(element).attr('isTipOpen') == 'false') {
                $(element).attr('isTipOpen', 'true');
                $(element).attr('title', ' ');
            } else {
                $(element).attr('isTipOpen', 'false');
                $(this).off('mouseout focusout', '**');
            }
        });
    });

    $('body').on('click', '.quickShopPopupShopNow', e => {
        e.preventDefault();
        // data-pid in ISML template
        e.target.nextElementSibling.click();
        var marks = document.querySelectorAll('.marks-items[isTipOpen="true"]');
        for (var i = 0; i < marks.length; i++) {
            marks[i].click();
        }
    });
}

/**
 * @description Initialization on the quick shop dialog content
 */
function initDialogContent($dialogContent) {
    uniform();
    pdpsize.init('.quickshop-dialog', 'quickshop');
    toggle.init();
    productTabs.init();
    variationCarousel.init();
    loadVideo();
    initImages($dialogContent);
    initVariantSelection($dialogContent);
    changeRegion($dialogContent);

    if (window.pageContext.ns !== 'wishlist') {
        gtmTracking.trackQuickShopMoreDetails();
    }
}

/**
 * @description Initialize the quick shop fly in base function
 */
function initOffCanvasDialog(isPopUp = false) {
    if (isPopUp) {
        PopupTip();
    } else {
        var dialog = offcanvasdialog.init(
            'marks-item-link',
            {
                overlay: true,
                preventScroll: true,
                contentStyle: 'overlaid',
                closeOnX: true,
                reloadContentAlways: true,
                additionalClass: 'quick-shop'
            },
            function ($triggerButton, $flyinContainer) {
                var $qsFlyInContent = $flyinContainer.find('.ocd-content');
                initFlyIn($qsFlyInContent);
            }
        );
    }
}

/**
 * @description Initialize the quick shop modal
 */
function initModalDialog() {
    $('body').on('click', '.quick-shop-button-dialog', function (event) {
        const $btn = $(this);

        modalDialog = new Dialog({
            additionalClasses: ['quickshop-dialog', 'quick-shop'],
            useLegacyContainer: true,
            hasTitleBar: true,
            hasCloseText: false,
            url: $btn.data('url'),
            callback: function () {
                $('body').addClass('ui-dialog-position-fixed');
                initDialogContent($('.quickshop-dialog .dialog-content'));
                $btn.attr('aria-expanded', 'true');

                // Initialize fit guide if it is not initialized yet and it is present on the page
                if (!fitguide.isInitialized() && $('.flyin-product-info-fit-guide').length > 0) {
                    fitguide.init();
                }
            },
            closeCallback: () => {
                $('body').removeClass('ui-dialog-position-fixed');
                $btn.attr('aria-expanded', 'false');
            }
        });
        modalDialog.open();
        event.preventDefault();
    });

    $('body').on('click', '.fylin-link', function (event) {
        if (modalDialog) {
            modalDialog.close();
        }
    });
}

/**
 * @description Initialize the in-grid quick shop content
 */
function initInGridContent($content) {
    pdpsize.init('.product-tile-quickshop-view', 'quickshop');
    initVariantSelection($content);
    changeRegion($content);
}

/**
 * @description Initialize the in-grid quick shop
 */
function initInGrid() {
    const $body = $('body');
    $body.on('click', '.quick-shop-button-in-grid', function (event) {
        const $btn = $(this);
        var $tile = $btn.parents('.product-tile-wrapper');

        var $quickshopTileView = $tile.find('.product-tile-quickshop-view');
        var $quickshopTileViews = $('.search-result-items .product-tile-quickshop-view');

        ajax.load({
            url: $btn.data('url'),
            target: $quickshopTileView,
            callback: function () {
                $quickshopTileViews.not($quickshopTileView).fadeOut();
                $quickshopTileView.fadeIn();
                initInGridContent($quickshopTileView);
            }
        });

        event.preventDefault();
    });

    $body.on('click', '.product-tile-quickshop-view .close-btn', function (event) {
        var $quickshopTileViews = $('.search-result-items .product-tile-quickshop-view');
        $quickshopTileViews.fadeOut();

        event.preventDefault();
    });
}

var quickShop = {
    init: function () {
        // Run on load

        $(document).ready(function () {
            initInGrid();
            initModalDialog();
            initOffCanvasDialog(window.useQuickShopPopup); //true for popup/flyIn, false for flyIn - -window.useQuickShopPopup
            hotspots.init();
        });

        gtmTracking.trackQuickShopOpenFliyin();
    },
    initFlyIn: initFlyIn
};

module.exports = quickShop;
